<script setup>
import { defineProps } from "vue";
import {
  svgProps,
  useSVGAccessibility,
} from "@/composables/useSVGAccessibility";

const props = defineProps({
  ...svgProps,
  fill: { type: String, default: "#007F80" },
  stroke: { type: String, default: "none" },
  strokeWidth: { type: String, default: "0" },
});

const { titleId, computedRole, ariaAttributes } = useSVGAccessibility(props);
</script>

<template>
  <svg
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 24 24"
    :fill="props.fill"
    :stroke="props.stroke"
    :stroke-width="props.strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="computedRole"
    v-bind="ariaAttributes"
  >
    <template v-if="props.title">
      <title :id="titleId">{{ props.title }}</title>
    </template>
    <g transform="translate(0.67,0) scale(1.333)">
      <g transform="translate(-23 -70)" fill="none" fill-rule="evenodd">
        <path
          d="m36.98 71.8-6.21 6.575a1.033 1.033 0 0 0 0 1.4.9.9 0 0 0 1.322 0l6.208-6.572V75.4c0 .496.38.9.85.9.468 0 .85-.403.85-.9V70.9a.926.926 0 0 0-.25-.635.824.824 0 0 0-.6-.264H34.9c-.47 0-.85.403-.85.9 0 .496.38.9.85.9h2.08zm3.02 9v-4.278 9.235C40 86.995 39.157 88 38.116 88H24.884C23.844 88 23 86.994 23 85.757V72.243c0-1.238.843-2.243 1.884-2.243h9.074H29.8c.47 0 .85.403.85.9 0 .498-.38.9-.85.9h-4.616c-.27 0-.484.27-.484.6v13.2c0 .325.217.6.484.6h12.632c.27 0 .484-.269.484-.6v-4.8c0-.497.38-.9.85-.9s.85.403.85.9z"
          :fill="props.fill"
        />
      </g>
    </g>
  </svg>
</template>
